import React, { useState, useEffect } from "react";
import "./formik-text-input.scss";
import classNames from "classnames";
import { useField } from "formik";
import InputUnstyled from "@mui/base/InputUnstyled";
import { ValidationError } from "@thrivetribe/mvf.ui.atoms.validation-error";

export type FormikTextInputProps = {
  name: string;
  placeholder?: string;
  className?: string;
  label?: string;
  errorMessage?: string;
  disabled?: boolean;
  [key: string]: any;
};

export const FormikTextInput: React.FC<FormikTextInputProps> = ({
  className,
  label,
  name,
  errorMessage,
  disabled,
  ...rest
}: FormikTextInputProps) => {
  const [field, meta] = useField(name);
  const [fieldDisabled, setFieldDisabled] = useState(false);

  useEffect(() => {
    if (disabled) {
      setFieldDisabled(true);
    } else {
      setFieldDisabled(false);
    }
  }, [disabled]);

  return (
    <>
      <label className="text-input__label">
        {label}
        <div>
          <InputUnstyled
            {...field}
            className={classNames("text-input", className)}
            disabled={fieldDisabled}
            error={
              (!!meta.error && meta.touched) || (errorMessage ? true : false)
            }
            {...rest}
          />
        </div>
        {meta.error != undefined && meta.touched && (
          <ValidationError errorMessage={meta.error} />
        )}

        {!meta.error && meta.touched && errorMessage && (
          <ValidationError errorMessage={errorMessage} />
        )}
      </label>
    </>
  );
};
